module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.overlayShow),
      expression: "overlayShow"
    }],
    staticClass: "overlay",
    on: {
      "click": _vm.hideOverlay
    }
  }, [_c('img', {
    staticClass: "overlay__img",
    attrs: {
      "src": './src/assets/' + _vm.pathImg,
      "alt": "pathImg"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "overlay__close",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.hideOverlay.apply(null, arguments)
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0066c5fd","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/overlay.vue
// module id = 48
// module chunks = 0